<template>
  <!-- 分析报告管理 -->
  <div class="page">
    <div class="paginations">
      <!-- 搜索表单 -->
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 省份 -->
          <el-form-item label="省份：" prop="province" class="demo-form-inline">
            <el-select
              size="small"
              v-model="searchData.province"
              clearable
              filterable
              style="width: 180px"
              @change="changeCity"
            >
              <el-option
                v-for="item in dropdown.provinceList"
                :key="item.zykid"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年份：" prop="Year" class="demo-form-inline">
            <el-select
              size="small"
              v-model="searchData.Year"
              clearable
              filterable
              style="width: 180px"
              @change="changeYear"
            >
              <el-option
                v-for="(item, index) in dropdown.YearList"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="月份：" prop="Month" class="demo-form-inline">
            <el-select
              size="small"
              v-model="searchData.Month"
              clearable
              filterable
              style="width: 180px"
              @change="changeMonth(searchData.Month)"
            >
              <el-option
                v-for="(item, index) in dropdown.MonthList"
                :key="index"
                :label="item.month"
                :value="item.month"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-button type="primary" @click="openDialog">单个zykid数据处理</el-button>
          <!-- 弹窗 -->
          <el-dialog title="单个zykid数据处理" :visible.sync="dialogVisible" width="50%" class="pop_up distribute">
            <el-form :model="formData">
              <el-form-item label="zykid">
                <el-input v-model="formData.zykid"></el-input>
              </el-form-item>
              <el-form-item label="类型">
                <el-input v-model="formData.data_type"></el-input>
              </el-form-item>
            </el-form>

            <!-- 按钮组 -->
            <div>
              <el-button type="primary" @click="startProcess">处理</el-button>
              <el-button type="success" @click="checkMongoData">查询</el-button>
            </div>

            <!-- 显示未处理数据 -->
            <div style="margin-top: 20px;">
              <span>未处理数据: {{ unprocessedData }}</span>
              <span> {{ unprocessedStatus }}</span>
            </div>
          </el-dialog>

        </el-form>
      </div>

      <!-- 表单内容 -->
      <div class="table_box">
        <el-table :data="tableObj.list" style="width: 100%">
          <el-table-column type="index" label="序号" align="center" width="120"> </el-table-column>
          <el-table-column prop="name" label="名称" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div>
                <i class="icona icon-details" title="查看年度报告" @click="see(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dialogVisible: false, // 控制弹窗显示
      formData: {
          zykid: '',
          data_type: ''
      },
      unprocessedStatus: '', // 查询状态
      unprocessedData: 0, // 查询结果
      searchData: {
        province: "北京市",
        province1: "北京",
        zykName: "",
        Year: "2023",
        Month: "01",
      },
      zykId: "",
      token: "",
      yearOrMonth: "",
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [
          {
            id: 1,
            name: "半年报",
            path: "/exportFenxi",
            zykName: sessionStorage.getItem("zykName"),
            token: sessionStorage.getItem("lrmv2token"),
            zykid: sessionStorage.getItem("zykId"),
            zykNum: sessionStorage.getItem("zykNum"),
          },
          {
            id: 8,
            name: "年报（含排名）",
            path: "/exportFenxiRank",
            zykName: sessionStorage.getItem("zykName"),
            token: sessionStorage.getItem("lrmv2token"),
            zykid: sessionStorage.getItem("zykId"),
            zykNum: sessionStorage.getItem("zykNum"),
            isRank: "yes",
          },
          {
            id: 12,
            name: "年报（不含排名）",
            path: "/exportFenxiRank",
            zykName: sessionStorage.getItem("zykName"),
            token: sessionStorage.getItem("lrmv2token"),
            zykid: sessionStorage.getItem("zykId"),
            zykNum: sessionStorage.getItem("zykNum"),
            isRank: "no",
          },
          {
            id: 2,
            name: "季报",
            path: "/exportJidu",
            zykName: sessionStorage.getItem("zykName"),
            zykNum: sessionStorage.getItem("zykNum"),
            zykid: sessionStorage.getItem("zykId"),
            token: sessionStorage.getItem("lrmv2token"),
            startDay: "2023-01-01",
            endDay: "2023-03-31",
          },
          {
            id: 3,
            name: "月报",
            path: "/exportMonthReport",
            zykName: sessionStorage.getItem("zykName"),
            zykNum: sessionStorage.getItem("zykNum"),
            zykid: sessionStorage.getItem("zykId"),
            token: sessionStorage.getItem("lrmv2token"),
          },
          {
            id: 4,
            name: "简报",
            path: "/exportyunxing",
            zykid: sessionStorage.getItem("zykId"),
            endDate: this.currentDate(),
            token: sessionStorage.getItem("lrmv2token"),
          },
          {
            id: 5,
            name: "国家级整体报告",
            path: "/exportcountryReport",
            token: sessionStorage.getItem("lrmv2token"),
            endDay: this.currentDate(),
            startDay: this.lastOneMonth(),
          },
          {
            id: 6,
            name: "省级整体报告Copy1",
            path: "/exportProvinceReportCopy1",
            endDay: this.currentDate(),
            startDay: this.lastOneMonth(),
            token: sessionStorage.getItem("lrmv2token"),
            province: "",
            province1: "",
            type: 1,
          },{
            id: 61,
            name: "省级整体报告Copy2",
            path: "/exportProvinceReportCopy2",
            endDay: this.currentDate(),
            startDay: this.lastOneMonth(),
            token: sessionStorage.getItem("lrmv2token"),
            province: "",
            province1: "",
            type: 1,
          },
          ,{
            id: 62,
            name: "1244资源库年度分析报告",
            path: "/exportFenxi1244",
            province: "北京",
            token: sessionStorage.getItem("lrmv2token"),
            zykid: sessionStorage.getItem("zykId"),
            startDay: "2023-09-01",
            endDay: "2024-09-30",
          },
          {
            id: 7,
            name: "个性化报告",
            path: "/individualizationReport",
            zykName: sessionStorage.getItem("zykName"),
            token: sessionStorage.getItem("lrmv2token"),
            zykid: sessionStorage.getItem("zykId"),
            zykNum: sessionStorage.getItem("zykNum"),
          },
          {
            id: 9,
            name: "月报（包含专业大数据）",
            path: "/exportMonthReportNew",
            zykName: sessionStorage.getItem("zykName"),
            zykNum: sessionStorage.getItem("zykNum"),
            zykid: sessionStorage.getItem("zykId"),
            token: sessionStorage.getItem("lrmv2token"),
          },
          {
            id: 10,
            name: "季报（包含专业大数据）",
            path: "/exportJiduNew",
            zykName: sessionStorage.getItem("zykName"),
            zykNum: sessionStorage.getItem("zykNum"),
            zykid: sessionStorage.getItem("zykId"),
            token: sessionStorage.getItem("lrmv2token"),
            startDay: "2023-01-01",
            endDay: "2023-03-31",
          },
          {
            id: 11,
            name: "国家端监测运行年报",
            path: "/exportCountryYearReport",
            zykName: sessionStorage.getItem("zykName"),
            zykNum: sessionStorage.getItem("zykNum"),
            zykid: sessionStorage.getItem("zykId"),
            endDay: this.getYear("e", 0),
            startDay: this.getYear("s", 0),
            token: sessionStorage.getItem("lrmv2token"),
          },
        ],
      },
      // 下拉框
      dropdown: {
        provinceList: [
          { name: "北京市" },
          { name: "天津市" },
          { name: "重庆市" },
          { name: "上海市" },
          { name: "河北省" },
          { name: "辽宁省" },
          { name: "山西省" },
          { name: "吉林省" },
          { name: "黑龙江省" },
          { name: "江苏省" },
          { name: "浙江省" },
          { name: "安徽省" },
          { name: "福建省" },
          { name: "江西省" },
          { name: "山东省" },
          { name: "河南省" },
          { name: "湖北省" },
          { name: "湖南省" },
          { name: "广东省" },
          { name: "海南省" },
          { name: "四川省" },
          { name: "贵州省" },
          { name: "云南省" },
          { name: "陕西省" },
          { name: "甘肃省" },
          { name: "青海省" },
          { name: "内蒙古" },
          { name: "广西省" },
          { name: "西藏" },
          { name: "宁夏" },
          { name: "新疆" },
        ],
        YearList: [{ name: "2020" }, { name: "2021" }, { name: "2022" }, { name: "2023" }],
        MonthList: [
          { month: "01" },
          { month: "02" },
          { month: "03" },
          { month: "04" },
          { month: "05" },
          { month: "06" },
          { month: "07" },
          { month: "08" },
          { month: "09" },
          { month: "10" },
          { month: "11" },
          { month: "12" },
        ],
      },

      endDate: "",
      // 资源库名称
    };
  },
  created() {
    this.zykId = sessionStorage.getItem("zykId");
    this.token = sessionStorage.getItem("lrmv2token");
    for (let i = 0; i < this.dropdown.provinceList.length; i++) {
      this.dropdown.provinceList[i].id = i + 1;
    }
    this.lastOneMonth();
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    this.searchData.Year = year;
    this.searchData.Month = month < 10 ? "0" + month : month;
  },
  methods: {
    // 打开弹窗(单个zykid数据处理)
    openDialog() {
        this.dialogVisible = true;
    },
    // 单个zykid数据处理
      startProcess() {
          this.unprocessedStatus='处理中!';
          this.$axios
              .post(this.$apiurls.startProcess,this.formData, {
                loading: false,
            })
            .then((res) => {
                if (res.code === 200) {
                    this.unprocessedStatus='处理完成!';
                }
            });
    },

    // 未处理数据查询
      checkMongoData() {
        this.$axios
            .post(this.$apiurls.checkMongoData,this.formData , {
                loading: false,
            })
            .then((res) => {
                if (res.code === 200) {
                    this.unprocessedData = res.data || 0; // 回显未处理数据
                }
            });
    },
    getYear(type, dates) {
      const dd = new Date();
      const n = dates || 0;
      const year = dd.getFullYear() + Number(n);
      if (type == "s") {
        var day = `${year}-01-01`;
      }
      if (type == "e") {
        var day = `${year}-12-31`;
      }
      if (!type) {
        var day = `${year}-01-01/${year}-12-31`;
      }
      return day;
    },
    // 当前的年 - 月 - 日
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1 > 10 ? date.getMonth() : `0${date.getMonth()}`;
      const day = date.getDate() > 10 ? date.getDate() : `0${date.getDate()}`;

      return `${year}-${month}-${day}`;
    },

    yearOrMonthHandler() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      this.searchData.Year = year;
      this.searchData.Month = month < 10 ? "0" + month : month;
      // return `${year}${month}`;
    },
    changeYear(i) {
      this.searchData.Year = i;
    },
    changeMonth(i) {
      i = i < 10 ? "0" + i : i;
      this.searchData.Month = i;
    },
    changeCity(i) {
      this.$nextTick(() => {
        if (i === "北京市" || i === "重庆市" || i === "天津市" || i === "上海市") {
          this.searchData.province1 = i.replace("市", "");
        } else {
          this.searchData.province1 = i.replace("省", "");
        }
      });
      this.searchData.province = i;
    },
    // 获取一个月前的日期
    lastOneMonth() {
      return moment(new Date()).subtract(1, "months").format("YYYY-MM-DD");
    },
    // 查看
    see(row) {
      if (row.id == 1) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&zykName=${row.zykName}&zykNum=${row.zykNum}`
        );
      }else if (row.id == 62) {
        window.open(
          `${row.path}?zykid=${row.zykid}&province=${row.province}&token=${row.token}&startDay=${row.startDay}&endDay=${row.endDay}`,
          "_blank"
        );
      } else if (row.id == 2) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&zykname=${row.zykName}&zykNum=${row.zykNum}&startDay=${row.startDay}&endDay=${row.endDay}`,
          "_blank"
        );
      } else if (row.id == 3) {
        window.open(
          `${row.path}?zykName=${row.zykName}&zykNum=${row.zykNum}&yearOrMonth=${this.searchData.Year}${this.searchData.Month}&zykid=${row.zykid}&token=${row.token}`,
          "_blank"
        );
      } else if (row.id == 4) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&endDate=${row.endDate}`,
          "_blank"
        );
      } else if (row.id == 5) {
        window.open(
          `${row.path}?token=${row.token}&type=1&startDay=${row.startDay}&endDay=${row.endDay}`,
          "_blank"
        );
      } else if (row.id == 6||row.id == 61) {
        window.open(
          `${row.path}?&startDay=${row.startDay}&endDay=${row.endDay}&type=${row.type}&province=${this.searchData.province}&province1=${this.searchData.province1}&token=${row.token}`,
          "_blank"
        );
      } else if (row.id == 7) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&zykName=${row.zykName}&zykNum=${row.zykNum}`,
          "_blank"
        );
      } else if (row.id == 8) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&zykName=${row.zykName}&zykNum=${row.zykNum}&isRank=${row.isRank}`,
          "_blank"
        );
      } else if (row.id == 9) {
        window.open(
          `${row.path}?zykName=${row.zykName}&zykNum=${row.zykNum}&yearOrMonth=${this.searchData.Year}${this.searchData.Month}&zykid=${row.zykid}&token=${row.token}`,
          "_blank"
        );
      } else if (row.id == 10) {
        window.open(
          `${row.path}?zykName=${row.zykName}&zykNum=${row.zykNum}&yearOrMonth=${this.searchData.Year}${this.searchData.Month}&zykid=${row.zykid}&token=${row.token}&startDay=${row.startDay}&endDay=${row.endDay}`,
          "_blank"
        );
      } else if (row.id == 11) {
        window.open(
          `${row.path}?token=${row.token}&type=1&startDay=${row.startDay}&endDay=${row.endDay}`,
          "_blank"
        );
      } else if (row.id == 12) {
        window.open(
          `${row.path}?zykid=${row.zykid}&token=${row.token}&zykName=${row.zykName}&zykNum=${row.zykNum}&isRank=${row.isRank}`,
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.el-form {
  height: 100%;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.search_button i {
  width: 33px;
  height: 33px;
  /* background: rgba(46, 62, 99, 0.79); */
  border-radius: 4px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
}
</style>

<style>
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: transparent;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  position: absolute;
  display: "";
  width: "";
  height: "";
  border: none;
  border-style: "";
}
.el-select-dropdown__list {
  box-sizing: border-box;
  padding: -1px 0;
  background: rgba(26, 38, 72) !important;
}
.el-select-dropdown__item {
  color: #fff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: transparent;
  border: 1px solid rgba(27, 246, 248);
}

.el-select-dropdown__item.selected {
  color: rgba(27, 246, 248);
}
</style>
